import { BottomNavigation, BottomNavigationAction } from '@mui/material'
import React  from 'react'
import { ReactComponent as Books } from "../assets/svg/books_menu.svg";
import { ReactComponent as Favorite } from "../assets/svg/star_menu.svg";
import { ReactComponent as Notification } from "../assets/svg/notif_menu.svg";
import { ReactComponent as Settings } from "../assets/svg/settings_menu.svg";
import { useHistory } from 'react-router-dom';
export default function BottomMenu() {
    const history = useHistory();
    const clickButton = (linkToGo) => (e) => {
        e.preventDefault();
        history.push(linkToGo)
    }
    return (
        <BottomNavigation
            showLabels
        >
            <BottomNavigationAction
                onClick={clickButton("/mybooks/reserve")}
                label="My Books"
                icon={<Books />}
            />
            <BottomNavigationAction
                onClick={clickButton("/bookmarks")}
                label="Bookmarks"
                icon={<Favorite />} />
            <BottomNavigationAction
                onClick={clickButton("/notifications")}
                label="Notifications"
                icon={<Notification />} />
            <BottomNavigationAction
                onClick={clickButton("/settings")}
                label="Settings"
                icon={<Settings />} />

        </BottomNavigation>
    )
}
